// Copyright 2026. WebPros International GmbH. All rights reserved.

import { Dispatch } from 'redux';
import { paginateList } from 'common/actions/actionsWrapper';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';
import {
    gpuModels,
    IGpuModel,
    IGpuModelsListRequest,
} from 'common/api/resources/Gpu';
import { createCustomAction } from 'typesafe-actions';
import * as types from 'common/modules/gpuModels/types';
import { IPaginateApiResponse } from 'common/api/resources/Response';

export const getGpuModels = (request?: IGpuModelsListRequest) => async (dispatch: Dispatch) => {
    const apiCall = () => gpuModels.list(request);

    return await paginateList({
        dispatch,
        loadingFlag: LOADING_FLAGS.GPU_MODELS,
        action: setGpuModelList,
        apiCall,
    });
};

export const setGpuModelList = createCustomAction(
    types.SET_GPU_MODELS,
    (data: IPaginateApiResponse<IGpuModel[]>) => ({ payload: data })
);
